// @flow

import { beginRequest, completeRequest } from "@store/utils";
import type { SpecialContactTypesState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetSpecialContactTypes = (state: SpecialContactTypesState) => () =>
  startRequest(state);

export const onGetSpecialContactTypesSuccess = (state: SpecialContactTypesState) => ({
  payload,
}: *) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetSpecialContactTypesError = (state: SpecialContactTypesState) => ({
  payload,
}: *) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});
